import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';
import { useGlobalStore } from '@old/global-store/use-store';
import { StockMovResponse } from './report-mov-stock-info.types';

// deprecated service ref.: getAllReportStockService_DEPRECATED
export async function stockMovementListService() {
  const { organizationId, filtersReportStock } = useGlobalStore.getState();
  const rawQuery = filtersReportStock;
  const query = transformIntoQueryParamString(organizationId, rawQuery);

  const { response, data } = await BACKEND.get<StockMovResponse>(ENDPOINT.REPORT_STOCK, { query });

  return {
    response,
    summary: data,
  };
}
